import * as React from "react";

export const IconAssignment = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g>
      <path
        d="M19.5 4.5H15.32C14.9 3.34 13.8 2.5 12.5 2.5C11.2 2.5 10.1 3.34 9.68 4.5H5.5C4.4 4.5 3.5 5.4 3.5 6.5V20.5C3.5 21.6 4.4 22.5 5.5 22.5H19.5C20.6 22.5 21.5 21.6 21.5 20.5V6.5C21.5 5.4 20.6 4.5 19.5 4.5ZM12.5 4.5C13.05 4.5 13.5 4.95 13.5 5.5C13.5 6.05 13.05 6.5 12.5 6.5C11.95 6.5 11.5 6.05 11.5 5.5C11.5 4.95 11.95 4.5 12.5 4.5ZM14.5 18.5H7.5V16.5H14.5V18.5ZM17.5 14.5H7.5V12.5H17.5V14.5ZM17.5 10.5H7.5V8.5H17.5V10.5Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
